<template>
  <div class="sender">
    <!-- TODO <p>{{message.sent_by | userFullName}}</p> -->
    <p
      v-if="isUser"
      class="ellipsis">{{ message.agent ? message.agent.name : '' }}</p>
    <p
      v-else-if="isTemplate"
      class="flex center-all" >
      <span class="ellipsis">Template message</span>
      <template v-if="message.agent && message.agent.name">
        <DotSeparator
          :size="3"
          class="ml-1 mr-1"/>
        <span class="ellipsis">{{ message.agent ? message.agent.name : '' }}</span>
      </template>
    </p>
    <span
      v-else-if="isBot"
      class="message-status flex flex-align-center">
      <SBIcon
        :icon="SBIconList.FLASH"
        color="#7c8b91"
        :size="10"/>
      <span>Automated response</span>
    </span>
  </div>
</template>

<script>
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import DotSeparator from '@/components/common/DotSeparator';

export default {
  name: 'Sender',
  components: {
    SBIcon,
    DotSeparator,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      SBIconList,
    };
  },
  computed: {
    isUser() {
      return this.message.direction === 'outbound';
    },
    isBot() {
      return this.message.direction === 'bot';
    },
    isTemplate() {
      return this.message.direction === 'template_message';
    },
  },
};
</script>

<style lang="scss" scoped>
.sender {
  min-width: 0px; // CS: Indicates to the flexbox layout that it is okay to shrink that child
}
</style>
